import { MDSIconKind } from "@/mds";
import type { AgentFilterSelectItem } from "@/pages/agent/components/agent-filter-select";
import { RoutineSortKey } from "@/pages/agent/routines/use-agent-routines-search-params";

export const buildRoutineSortFilterItems = (): AgentFilterSelectItem[] => [
  {
    id: RoutineSortKey.NextRun,
    label: "Next run",
    iconKind: MDSIconKind.SortAlt,
  },
  {
    id: RoutineSortKey.RecentlyUpdated,
    label: "Recently updated",
    iconKind: MDSIconKind.SortAlt,
  },
  {
    id: RoutineSortKey.Name,
    label: "Name",
    iconKind: MDSIconKind.SortAlt,
  },
];
